/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { environment } from "../environment";
import { HttpClientOptions } from "../Utils/HttpClient";
import ApiClient from "./ApiClient";

export default abstract class SystemApiClient extends ApiClient {
    protected constructor(path: string, options?: HttpClientOptions) {
        super(`${environment.sysBaseUrl}/${path}`, options);
    }
}
